'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function ChooseSubLineController(Auth, $state, SidebarService, $filter, $stateParams, $scope, CityComponent, SubLineComponent, PageHeading, Toast) {
	'ngInject';

	var vm = this;
	vm.searchCities = CityComponent.searchCities;
	vm.getResultSearchCities = CityComponent.getResultSearchCities;
	vm.getGoingSubLines = SubLineComponent.getGoingSubLines;
	vm.getReturnSubLines = SubLineComponent.getReturnSubLines;
	vm.clearResults = CityComponent.clearResultSearchCities;
	vm.selectFromCity = selectFromCity;
	vm.selectToCity = selectToCity;
	vm.searchSubLines = searchSubLines;
	vm.navigateToCreateReservation = navigateToCreateReservation;
	vm.navigateToEditReservation = navigateToEditReservation;
	vm.chooseBus = chooseBus;
	vm.searchCriteria = { 'ticket_type': 'one_way' };
	vm.getGoingPaginationInfo = SubLineComponent.getGoingPaginationInfo;
	vm.getReturnPaginationInfo = SubLineComponent.getReturnPaginationInfo;
	vm.yesterdayDate = new Date();
	vm.yesterdayDate.setDate(vm.yesterdayDate.getDate() - 1);
	vm.seatId = $stateParams.seatId;
	vm.fromCity = {};
	vm.toCity = {};
	vm.choosenDates = {};
	vm.permitedUser = true;

	var watchForUser = $scope.$watch(function () {
		if (Object.keys(Auth.getCurrentUser()).length !== 0) {
			var currentUser = Auth.getCurrentUser().roles[0].name;

			vm.permitedUser = checkPermissions(currentUser);
			watchForUser();
		}
	});

	activate();

	function activate() {
		var heading = $filter('translate')('HEADING.BUYING_TICKET');
		var title = 'BTMS | ' + $filter('translate')('HEADING.BUYING_TICKET');

		PageHeading.setPageHeading(heading, title);
		SubLineComponent.clearGoingSubLines();
		SubLineComponent.clearReturnSubLines();
	}

	/** check if user has permissions to edit reservations for early perriod */
	function checkPermissions(user) {
		var permitedUsers = ['owner', 'administrator'];

		if (permitedUsers.indexOf(user) !== -1) {
			return true;
		} else {
			return false;
		}
	}

	function selectFromCity(city) {
		vm.queryFrom = city.translation.name;
		vm.fromCity = city;
	}

	function selectToCity(city) {
		vm.queryTo = city.translation.name;
		vm.toCity = city;
	}

	function searchSubLines(params, dateReturn) {
		SubLineComponent.clearGoingSubLines();
		SubLineComponent.clearReturnSubLines();

		vm.goingBusId = '';
		vm.returnBusId = '';
		vm.goingSubLineId = '';
		vm.returnSubLineId = '';

		var hasErrors = false;

		if ($scope.searchSubLines.$error.required) {
			hasErrors = true;

			return false;
		}

		if (hasErrors || !vm.searchCriteria.ticket_type) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		params.from_city_id = vm.fromCity.id;
		params.to_city_id = vm.toCity.id;

		SubLineComponent.searchSubLines(params, 'going').then(function (res) {
			if (res.data && res.data.errors) {
				Toast.responseError(res.data.errors);
			} else if (!res.length) {
				Toast.info($filter('translate')('NOT_FOUND.GOING_SUBLINES'));
			}
		});

		if (params.ticket_type === 'return') {
			var returnSubLineParams = JSON.parse(JSON.stringify(params));
			returnSubLineParams.from_city_id = vm.toCity.id;
			returnSubLineParams.to_city_id = vm.fromCity.id;
			returnSubLineParams.date = dateReturn;

			SubLineComponent.searchSubLines(returnSubLineParams, 'return').then(function (res) {
				if (res.data && res.data.errors) {
					Toast.responseError(res.data.errors);
				} else if (!res.length) {
					Toast.info($filter('translate')('NOT_FOUND.RETURN_SUBLINES'));
				}
			});
		}
	}

	function chooseBus(busId, subLineId, direction, date) {
		if (direction === 'going') {
			vm.goingBusId = busId;
			vm.goingSubLineId = subLineId;
			vm.choosenDates.going = date;
		} else {
			vm.returnBusId = busId;
			vm.returnSubLineId = subLineId;
			vm.choosenDates['return'] = date;
		}
	}

	function navigateToCreateReservation(goingBusId, returnBusId, goingSubLineId, returnSubLineId, ticketType, dates) {
		if (!goingBusId) {
			Toast.error($filter('translate')('ERRORS.REQUIRED_GOING_LINE'));

			return false;
		}

		if (!returnBusId && ticketType === 'return') {
			Toast.error($filter('translate')('ERRORS.REQUIRED_RETURN_LINE'));

			return false;
		}

		$state.go('app.private.tickets.create', {
			'date': dates.going,
			'returnDate': dates['return'],
			returnBusId: returnBusId,
			ticketType: ticketType,
			returnSubLineId: returnSubLineId,
			'busId': goingBusId,
			'subLineId': goingSubLineId
		});
	}

	function navigateToEditReservation(busId, date, seatId, subLineId) {
		if (!busId) {
			Toast.error($filter('translate')('ERRORS.REQUIRED_GOING_LINE'));

			return false;
		}

		$state.go('app.private.tickets.edit', {
			busId: busId,
			date: date,
			seatId: seatId,
			subLineId: subLineId
		});
	}
}

exports['default'] = ChooseSubLineController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/tickets/choose-sub-line/choose-sub-line.controller.js
 **/